const getDataLayer = () => {
  if (typeof window === 'undefined') {
    return [];
  }
  return window?.dataLayer || [];
};

export default getDataLayer;
